import { State } from 'jumpstate'

const LogoutState = State({
  initial: {
    isLoggingOut: false
  },
  logoutBegin (state) {
    return Object.assign({}, state, {
      isLoggingOut: true
    })
  }
})

export default LogoutState



// WEBPACK FOOTER //
// ./src/components/Logout/state.js